<template>
	<div>
		<a-spin :spinning="loading">
      <a-form ref="modelRef" name="modelRef">

        <a-divider>线上会员卡</a-divider>
        <a-form-item label="选择用户线上会员卡文件">
          <a-upload v-model:file-list="cardFileList" list-type="picture" action="/admin/ajaxUpload.do"
                    accept=".xlsx" :max-count="1" :beforeUpload="beforeUpload">
            <a-button>
              <Icon icon="UploadOutlined"></Icon>
              上传
            </a-button>
          </a-upload>
        </a-form-item>
        <a-button @click="onCardFileListUpload" type="primary">执行导入用户线上会员卡</a-button>
        <a style="margin-left: 20px" href="http://mall-cinema-base.oss-cn-guangzhou.aliyuncs.com/temp/%E7%BA%BF%E4%B8%8A%E4%BC%9A%E5%91%98%E5%8D%A1%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF-20260601.xlsx">线上会员卡模板</a>

        <a-divider>兑换券</a-divider>
        <a-form-item label="步骤1,导入全部兑换券" extra="用于导入全部兑换券数据, 全部写入到兑换券列表, 完成后才能进行步骤2, 速度较快">
          <a-upload v-model:file-list="couponFileList" list-type="picture" action="/admin/ajaxUpload.do"
                    accept=".xlsx" :max-count="1" :beforeUpload="beforeUpload">
            <a-button>
              <Icon icon="UploadOutlined"></Icon>
              上传
            </a-button>
          </a-upload>
        </a-form-item>
        <a-button style="margin-bottom: 50px" @click="onCouponFileListUpload" type="primary">执行导入全部兑换券</a-button>
        <a style="margin-left: 20px" href="https://mall-cinema-base.oss-cn-guangzhou.aliyuncs.com/temp/%E5%85%91%E6%8D%A2%E5%88%B8%E6%AD%A5%E9%AA%A41.xlsx">全部兑换券模板</a>
        <a-divider/>
        <a-form-item label="步骤2,导入用户兑换券" extra="用于绑定用户与券的关系, 需要一张张卡处理, 速度很慢">
          <a-upload v-model:file-list="userCouponFileList" list-type="picture" action="/admin/ajaxUpload.do"
                    accept=".xlsx" :max-count="1" :beforeUpload="beforeUpload">
            <a-button>
              <Icon icon="UploadOutlined"></Icon>
              上传
            </a-button>
          </a-upload>
        </a-form-item>
        <a-button @click="onUserCouponFileListUpload" type="primary">执行导入用户兑换券</a-button>
        <a style="margin-left: 20px" href="https://mall-cinema-base.oss-cn-guangzhou.aliyuncs.com/temp/%E5%85%91%E6%8D%A2%E5%88%B8%E6%AD%A5%E9%AA%A42.xlsx">用户兑换券模板</a>

        <a-divider>用户次卡</a-divider>
        <a-form-item label="选择用户次卡文件">
          <a-upload v-model:file-list="userCardFileList" list-type="picture" action="/admin/ajaxUpload.do"
                    accept=".xlsx" :max-count="1" :beforeUpload="beforeUpload">
            <a-button>
              <Icon icon="UploadOutlined"></Icon>
              上传
            </a-button>
          </a-upload>
        </a-form-item>
        <a-button @click="onUserCardFileListUpload" type="primary">执行导入用户次卡</a-button>
        <a style="margin-left: 20px" href="https://mall-cinema-base.oss-cn-guangzhou.aliyuncs.com/temp/%E5%AF%BC%E5%85%A5%E7%94%A8%E6%88%B7%E6%AC%A1%E5%8D%A1%E6%A8%A1%E6%9D%BF.xlsx">用户次卡模板</a>


<!--        <a-divider>用户年卡</a-divider>-->


      </a-form>
		</a-spin>
	</div>
</template>

<script>
  import {
    importUserRechargeCard,
    importCoupon,
    importUserCoupon,
    importUserNumberCard
  } from '@/service/modules/import.js';
	export default {
		data() {
			return {
				loading: false,
				modelRef: {},
        cardFileList: [],
        couponFileList: [],
        userCouponFileList: [],
        userCardFileList: [], // 次卡
			}
		},
		created() {

		},
		methods: {
      beforeUpload(file) {
        const isLt1M = file.size / 1024 / 1024 < 5;
        if (!isLt1M) {
          this.$message.error('上传文件太大了, 最大只允许5M');
        }
        return false;
      },
      async onCardFileListUpload() {
        if (this.cardFileList.length === 0) {
          return this.$message.warn('请上传文件');
        }
        const isLt5M = this.cardFileList[0].size / 1024 / 1024 < 5;
        if (!isLt5M) {
          this.$message.error('上传文件太大了, 最大只允许5M');
        }
        this.loading = true;
        try {
          let ret = await importUserRechargeCard({}, this.cardFileList[0]);
          this.loading = false;
          if (ret.code === 200) {
            this.$message.success('导入成功, 请在线上会员用户表查看最后一张会员卡是否正确导入');
            this.cardFileList = [];
          } else {
            this.cardFileList = [];
          }
        } catch(e) {
          this.loading = false;
        }
      },
      async onCouponFileListUpload() {
        if (this.couponFileList.length === 0) {
          return this.$message.warn('请上传文件');
        }
        const isLt5M = this.couponFileList[0].size / 1024 / 1024 < 5;
        if (!isLt5M) {
          this.$message.error('上传文件太大了, 最大只允许5M');
        }
        this.loading = true;
        try {
          let ret = await importCoupon({}, this.couponFileList[0]);
          this.loading = false;
          if (ret.code === 200) {
            this.$message.success('导入成功, 请在兑换券列表查看最后一张兑换券是否正确导入');
            this.couponFileList = [];
          } else {
            this.couponFileList = [];
          }
        } catch(e) {
          this.loading = false;
        }
      },
      async onUserCouponFileListUpload() {
        if (this.userCouponFileList.length === 0) {
          return this.$message.warn('请上传文件');
        }
        const isLt5M = this.userCouponFileList[0].size / 1024 / 1024 < 5;
        if (!isLt5M) {
          this.$message.error('上传文件太大了, 最大只允许5M');
        }
        this.loading = true;
        try {
          let ret = await importUserCoupon({}, this.userCouponFileList[0]);
          this.loading = false;
          if (ret.code === 200) {
            this.$message.success('导入成功');
            this.userCouponFileList = [];
          } else {
            this.userCouponFileList = [];
            setTimeout(()=>{
              this.$message.success('应该是进行中, 一条数据需要0.5s, 可以计算一下花费时间去看看兑换券信息最后一条数据对不对');
            }, 7000)
          }
        } catch(e) {
          this.loading = false;
        }
      },
      async onUserCardFileListUpload() {
        // 用户次卡
        if (this.userCardFileList.length === 0) {
          return this.$message.warn('请上传文件');
        }
        const isLt5M = this.userCardFileList[0].size / 1024 / 1024 < 5;
        if (!isLt5M) {
          this.$message.error('上传文件太大了, 最大只允许5M');
        }
        this.loading = true;
        try {
          let ret = await importUserNumberCard({}, this.userCardFileList[0]);
          this.loading = false;
          if (ret.code === 200) {
            this.$message.success('导入成功, 请在次卡信息表查看最后一张次卡是否正确导入');
            this.userCardFileList = [];
          } else {
            this.userCardFileList = [];
          }
        } catch(e) {
          this.loading = false;
        }
      },
		}
	}
</script>

<style scoped>
	.ui-form-item {
		margin-right: 20px;
	}
</style>
